import React from "react";
import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { Error, Hint, Label } from "@progress/kendo-react-labels";
import RichTextEditor from "./RichTextEditor";

const FormRichTextField = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    defaultContent,
    style = { height: "100px" },
    wrapperStyle,
    wrapperClassName,
    value,
    onChange,
    astrike = false,
    maxHeight = 500,
    minHeight = 100,
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  const handleEditorChange = (newValue: string) => {
    onChange({ value: newValue });
  };

  const editorHeight = style?.height ? parseInt(style.height.toString()) : minHeight;

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
        className="k-form-label"
      >
        {label} {astrike && <span style={{ color: "red" }}>*</span>}
      </Label>
      <div className={`k-form-field-wrap ${wrapperClassName || ""}`}>
        <div 
          style={{ 
            opacity: disabled ? 0.6 : 1, 
            pointerEvents: disabled ? 'none' : 'auto' 
          }}
        >
          <RichTextEditor
            content={value || defaultContent || ""}
            onChange={handleEditorChange}
            maxHeight={maxHeight}
            minHeight={minHeight || Math.max(editorHeight, minHeight)}
          />
        </div>
        {showHint && <Hint id={hintId}>{hint}</Hint>}
        {showValidationMessage && (
          <Error id={errorId}>{validationMessage}</Error>
        )}
      </div>
    </FieldWrapper>
  );
};

export default FormRichTextField;